export const SEARCH_ALLOWEDLIST = "SEARCH_ALLOWEDLIST";
export const FACET_FINDINGAIDS = "FACET_FINDINGAIDS";
export const SEARCH_FINDINGAIDS = "SEARCH_FINDINGAIDS";
export const SEARCH_FINDINGAID = "SEARCH_FINDINGAID";
export const SEARCH_REPOSITORIES = "SEARCH_REPOSITORIES";
export const SEARCH_CREATORS = "SEARCH_CREATORS";
export const SORT_FINDINGAIDS = "SORT_FINDINGAIDS";
export const RESET_FINDINGAIDS = "RESET_FINDINGAIDS";
